export const requiredFields = [
    // 'barcode',
    'date',
    'qty',
    'name',
    // 'customer_subtotal',
    // 'customer_final_subtotal'
];
